






import { Vue, Component, Prop } from 'vue-property-decorator';
import CentralView from '@/CentralView.vue';

@Component({
  components: {
    CentralView,
  }
})
export default class BoxCompare extends Vue {
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BoxCompare.vue